import { useState, type InputHTMLAttributes } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { Field } from '../ds/index'
import { Icon } from './Icon'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & { label: string }

/**
 * A password field with an eye to show what was typed. Every password input in
 * the app uses this, so the control is the same on sign-in, first sign-in,
 * reset and Settings. It starts hidden; the reveal is per field and is not kept.
 */
export function PasswordField({ label, id, className, ...props }: Props) {
  const [shown, setShown] = useState(false)
  const fieldId = id ?? label.toLowerCase().replace(/\s+/g, '-')
  return (
    <div className="form-row">
      <label className="field-label" htmlFor={fieldId}>{label}</label>
      <div className="pw-wrap">
        <Field id={fieldId} type={shown ? 'text' : 'password'} className={['pw-input', className].filter(Boolean).join(' ')} {...props} />
        <button type="button" className="pw-toggle" aria-label={shown ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
          aria-pressed={shown} onClick={() => setShown((s) => !s)} disabled={props.disabled}>
          <Icon of={shown ? EyeOff : Eye} />
        </button>
      </div>
    </div>
  )
}
